var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.58729 8.77885C4.36672 10.5479 7.47002 13 11.0007 13C14.5313 13 17.634 10.5479 19.4135 8.77885C19.8828 8.31231 20.1182 8.07823 20.2676 7.62016C20.3743 7.29333 20.3743 6.70678 20.2676 6.37995C20.1182 5.92185 19.8828 5.68775 19.4135 5.22115C17.634 3.45213 14.5313 1.00005 11.0007 1.00005C7.47002 1.00005 4.36672 3.45213 2.58729 5.22115C2.11763 5.68807 1.88277 5.92169 1.73328 6.37995C1.62667 6.70678 1.62667 7.29333 1.73328 7.62016C1.88277 8.07842 2.11762 8.31194 2.58729 8.77885Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00049 7.00005C9.00049 8.10462 9.89592 9.00005 11.0005 9.00005C12.1051 9.00005 13.0005 8.10462 13.0005 7.00005C13.0005 5.89548 12.1051 5.00005 11.0005 5.00005C9.89592 5.00005 9.00049 5.89548 9.00049 7.00005Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.96f23d629b6bd481ad9e2759b734e303.svg";
export { ForwardRef as ReactComponent };